import { createOverlayComponent } from '@react-leaflet/core';
import { Tooltip as LeafletTooltip } from 'leaflet';
import { useEffect } from 'react';
export var Tooltip = createOverlayComponent(function createTooltip(props, context) {
  return {
    instance: new LeafletTooltip(props, context.overlayContainer),
    context: context
  };
}, function useTooltipLifecycle(element, context, props, setOpen) {
  var onClose = props.onClose,
      onOpen = props.onOpen;
  useEffect(function addTooltip() {
    var container = context.overlayContainer;

    if (container == null) {
      return;
    }

    var instance = element.instance;

    var onTooltipOpen = function onTooltipOpen(event) {
      if (event.tooltip === instance) {
        instance.update();
        setOpen(true);
        onOpen == null ? void 0 : onOpen();
      }
    };

    var onTooltipClose = function onTooltipClose(event) {
      if (event.tooltip === instance) {
        setOpen(false);
        onClose == null ? void 0 : onClose();
      }
    };

    container.on({
      tooltipopen: onTooltipOpen,
      tooltipclose: onTooltipClose
    });
    container.bindTooltip(instance);
    return function removeTooltip() {
      container.off({
        tooltipopen: onTooltipOpen,
        tooltipclose: onTooltipClose
      });
      container.unbindTooltip();
    };
  }, [element, context, setOpen, onClose, onOpen]);
});